module.exports = __webpack_public_path__ + "img/bjfooter.684ef2c4.png";